"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
var material_1 = require("@mui/material");
var React = require("react");
require("./Assign_Region.scss");
var checkbox_component_1 = require("../../../common/checkbox/checkbox_component");
var react_virtualized_1 = require("react-virtualized");
var pop_up_1 = require("../../../common/modal/pop-up");
var button_component_1 = require("../../../common/buttons/button_component");
var search_component_1 = require("../../../common/search/search_component");
var RegionSelector = function (_a) {
    var _b;
    var setSelectedStates = _a.setSelectedStates, setSelectedCities = _a.setSelectedCities, setSelectedLabs = _a.setSelectedLabs, selectedStates = _a.selectedStates, selectedCities = _a.selectedCities, selectedLabs = _a.selectedLabs, company = _a.company, setCities = _a.setCities, setLabs = _a.setLabs, cities = _a.cities, labs = _a.labs, statesData = _a.statesData, allCitiesData = _a.allCitiesData, allLabsData = _a.allLabsData;
    var _c = React.useState(false), isLabExist = _c[0], setIsLabExist = _c[1];
    var _d = React.useState(false), isLabExistDetails = _d[0], setIsLabExistDetails = _d[1];
    var _e = React.useState(''), searchTerm = _e[0], setSearchTerm = _e[1];
    var _f = React.useState([]), filteredCities = _f[0], setFilteredCities = _f[1];
    var _g = React.useState([]), filteredLabs = _g[0], setFilteredLabs = _g[1];
    var selectedFeatureHandler = function (event, moduleName, featureId, section, featureName, allModuleData, selectedData, items, selectedObj) {
        var _a, _b, _c, _d, _e;
        var _f;
        if (event.target.checked) {
            if (Object.keys(selectedData).length > 0) {
                if (selectedData[moduleName] != undefined) {
                    var isExist = selectedData[moduleName].some(function (module) { return module.name.toLowerCase() === featureName.toLowerCase(); });
                    if (!isExist) {
                        var selectedArray = selectedData[moduleName];
                        selectedArray.push(selectedObj);
                        var obj = __assign(__assign({}, selectedData), (_a = {}, _a[moduleName] = selectedArray, _a));
                        if (section === 'States') {
                            setSelectedStates(obj);
                        }
                        else if (section === 'Cities') {
                            setSelectedCities(obj);
                        }
                        else if (section === 'Labs') {
                            setSelectedLabs(obj);
                        }
                    }
                    else {
                        var selectedArray = selectedData[moduleName].filter(function (moduleDetails) { return moduleDetails.name.toLowerCase() != featureName.toLowerCase(); });
                        var obj = __assign(__assign({}, selectedData), (_b = {}, _b[moduleName] = selectedArray, _b));
                        if (section === 'States') {
                            var updatedCities = Object.fromEntries(Object.entries(selectedCities).filter(function (_a) {
                                var key = _a[0];
                                return key.toLowerCase() !== featureName.toLowerCase();
                            }));
                            var unselectedCitiesData = selectedCities[featureName];
                            if ((unselectedCitiesData === null || unselectedCitiesData === void 0 ? void 0 : unselectedCitiesData.length) > 0) {
                                var updatedLabs_1;
                                unselectedCitiesData.filter(function (cityInfo) {
                                    updatedLabs_1 = Object.fromEntries(Object.entries(selectedLabs).filter(function (_a) {
                                        var key = _a[0];
                                        return key !== cityInfo.name;
                                    }));
                                });
                                setSelectedLabs(updatedLabs_1);
                            }
                            setSelectedCities(updatedCities);
                            setSelectedStates(obj);
                        }
                        else if (section === 'Cities') {
                            var updatedLabs = Object.fromEntries(Object.entries(selectedLabs).filter(function (_a) {
                                var key = _a[0];
                                return key.toLowerCase() !== featureName.toLowerCase();
                            }));
                            setSelectedLabs(updatedLabs);
                            setSelectedCities(obj);
                        }
                        else if (section === 'Labs') {
                            setSelectedLabs(obj);
                        }
                    }
                }
                else {
                    var obj = __assign(__assign({}, selectedData), (_c = {}, _c[moduleName] = [selectedObj], _c));
                    if (section === 'States') {
                        setSelectedStates(obj);
                    }
                    else if (section === 'Cities') {
                        setSelectedCities(obj);
                    }
                    else if (section === 'Labs') {
                        setSelectedLabs(obj);
                    }
                }
            }
            else {
                if (section === 'States') {
                    var obj = {};
                    obj[moduleName] = [selectedObj];
                    setSelectedStates(obj);
                }
                else if (section === 'Cities') {
                    var obj = {};
                    obj[moduleName] = [selectedObj];
                    setSelectedCities(obj);
                }
                else if (section === 'Labs') {
                    var obj = {};
                    obj[moduleName] = [selectedObj];
                    setSelectedLabs(obj);
                }
            }
        }
        else {
            var isExist = selectedData[moduleName].some(function (module) { return module.name.toLowerCase() === featureName.toLowerCase(); });
            if (!isExist) {
                var selectedArray = selectedData[moduleName];
                selectedArray.push(selectedObj);
                var obj = __assign(__assign({}, selectedData), (_d = {}, _d[moduleName] = selectedArray, _d));
                if (section === 'States') {
                    setSelectedStates(obj);
                }
                else if (section === 'Cities') {
                    setSelectedCities(obj);
                }
                else if (section === 'Labs') {
                    setSelectedLabs(obj);
                }
            }
            else {
                var selectedArray = selectedData[moduleName].filter(function (moduleDetails) { return moduleDetails.name.toLowerCase() != featureName.toLowerCase(); });
                var obj = __assign(__assign({}, selectedData), (_e = {}, _e[moduleName] = selectedArray, _e));
                if (section === 'States') {
                    var unselectedStateCities = selectedCities[selectedObj.name];
                    var isLabsAvailable_1 = false;
                    if (unselectedStateCities) {
                        unselectedStateCities.forEach(function (cityData) {
                            if (selectedLabs[cityData.name].length > 0) {
                                isLabsAvailable_1 = true;
                            }
                        });
                    }
                    if (!isLabsAvailable_1) {
                        var updatedCities_1 = Object.fromEntries(Object.entries(selectedCities).filter(function (_a) {
                            var key = _a[0];
                            return key.toLowerCase() !== featureName.toLowerCase();
                        }));
                        var updatedLabs_2 = {};
                        Object.keys(updatedCities_1).forEach(function (key) {
                            console.log(key, updatedCities_1[key]);
                            updatedCities_1[key].forEach(function (cityDetails) {
                                updatedLabs_2[cityDetails.name] = selectedLabs[cityDetails.name];
                            });
                        });
                        setSelectedLabs(updatedLabs_2);
                        setSelectedCities(updatedCities_1);
                        setSelectedStates(obj);
                    }
                    else {
                        var labExistDetails = {
                            moduleName: moduleName,
                            section: section,
                            featureName: featureName,
                            selectedData: selectedData
                        };
                        setIsLabExistDetails(labExistDetails);
                        setIsLabExist(true);
                    }
                }
                else if (section === 'Cities') {
                    var isLabsAvailable = false;
                    if (((_f = selectedLabs[selectedObj.name]) === null || _f === void 0 ? void 0 : _f.length) > 0) {
                        isLabsAvailable = true;
                    }
                    if (!isLabsAvailable) {
                        var updatedLabs = Object.fromEntries(Object.entries(selectedLabs).filter(function (_a) {
                            var key = _a[0];
                            return key.toLowerCase() !== featureName.toLowerCase();
                        }));
                        setSelectedLabs(updatedLabs);
                        setSelectedCities(obj);
                    }
                    else {
                        var labExistDetails = {
                            moduleName: moduleName,
                            section: section,
                            featureName: featureName,
                            selectedData: selectedData
                        };
                        setIsLabExistDetails(labExistDetails);
                        setIsLabExist(true);
                    }
                }
                else if (section === 'Labs') {
                    setSelectedLabs(obj);
                }
            }
        }
    };
    var selectAllHandler = function (event, section) {
        if (event.target.checked) {
            if (section === 'Cities') {
                var obj_1 = {};
                cities.map(function (cityDetails) {
                    obj_1[cityDetails.name] = cityDetails.regions;
                });
                setSelectedCities(obj_1);
            }
            else if (section === 'Labs') {
                var obj_2 = {};
                labs.map(function (cityDetails) {
                    obj_2[cityDetails.name] = cityDetails.regions;
                });
                setSelectedLabs(obj_2);
            }
        }
        else {
            if (section === 'Cities') {
                setSelectedCities([]);
            }
            else if (section === 'Labs') {
                setSelectedLabs([]);
            }
        }
    };
    var selectAllModuleWiseHandler = function (event, moduleName, moduleRegions, selectedData, section, allModuleData, moduleData) {
        var _a;
        if (event.target.checked) {
            var updatedData = __assign(__assign({}, selectedData), (_a = {}, _a[moduleName] = moduleRegions, _a));
            if (section === 'States') {
                setSelectedStates(updatedData);
            }
            else if (section === 'Cities') {
                setSelectedCities(updatedData);
            }
            else if (section === 'Labs') {
                setSelectedLabs(updatedData);
            }
            if (section === 'States') {
                setCities(allCitiesData);
            }
            else {
                if (section === 'Cities') {
                    var filteredData_1 = allModuleData.filter(function (module) { return module.name === moduleName; });
                    var isExist = moduleData.some(function (module) { return module.name === moduleName; });
                    if (isExist) {
                        moduleData.map(function (moduleData) {
                            var _a;
                            if (moduleData.name === moduleName) {
                                return __assign(__assign({}, moduleData), (_a = {}, _a[moduleName] = moduleRegions, _a));
                            }
                        });
                    }
                    else {
                        if (labs.length === allLabsData.length) {
                            setLabs(filteredData_1);
                        }
                        else {
                            setLabs(function (prev) { return __spreadArray(__spreadArray([], prev, true), filteredData_1, true); });
                        }
                    }
                }
            }
        }
        else {
            var updatedData = Object.fromEntries(Object.entries(selectedData).filter(function (_a) {
                var key = _a[0];
                return key !== moduleName;
            }));
            if (section === 'States') {
                setSelectedStates(updatedData);
                setSelectedCities([]);
                setSelectedLabs([]);
            }
            else if (section === 'Cities') {
                setSelectedCities(updatedData);
            }
            else if (section === 'Labs') {
                setSelectedLabs(updatedData);
            }
            if (section === 'States') {
                setCities([]);
                setLabs([]);
            }
            else {
                if (section === 'Cities') {
                    var filteredData = moduleData.filter(function (moduleDetails) { return moduleDetails.name !== moduleName; });
                    if (filteredData.length < 1) {
                        setLabs(allLabsData);
                    }
                    else {
                        setLabs(filteredData);
                    }
                }
            }
        }
    };
    var checkIsSelected = React.useCallback(function (name, moduleName, selectedData) {
        var _a, _b;
        return (_b = (_a = selectedData[moduleName]) === null || _a === void 0 ? void 0 : _a.some(function (item) { return (item === null || item === void 0 ? void 0 : item.name) === name; })) !== null && _b !== void 0 ? _b : false;
    }, []);
    var isAllSelectedModuleWise = React.useCallback(function (feature, moduleName, selectedData) {
        if (!selectedData[moduleName])
            return false;
        return feature.regions.every(function (region) {
            return selectedData[moduleName].some(function (selectedRegion) { return (selectedRegion === null || selectedRegion === void 0 ? void 0 : selectedRegion.name) === (region === null || region === void 0 ? void 0 : region.name); });
        });
    }, []);
    var isAllModulesSelected = function (allModuleData, selectedData) {
        if (!selectedData || Object.keys(selectedData).length === 0) {
            return false;
        }
        var allModuleNames = Array.from(new Set(allModuleData.map(function (module) { return module.name; })));
        return allModuleNames.every(function (moduleName) {
            var moduleInData = allModuleData.find(function (module) { return module.name === moduleName; });
            var selectedModuleRegions = selectedData[moduleName];
            return (selectedModuleRegions &&
                selectedModuleRegions.length === (moduleInData === null || moduleInData === void 0 ? void 0 : moduleInData.regions.length));
        });
    };
    React.useEffect(function () {
        if (Object.keys(selectedStates).length > 0) {
            var filteredData_2 = [];
            selectedStates['All States'].forEach(function (stateDetails) {
                if (allCitiesData.length > 0) {
                    allCitiesData.map(function (citydetails) {
                        if (stateDetails.name.toLowerCase() === citydetails.name.toLowerCase()) {
                            filteredData_2.push(citydetails);
                        }
                    });
                }
            });
            setCities(filteredData_2);
            setLabs([]);
        }
        if (Object.keys(selectedCities).length > 0) {
            var filteredData_3 = [];
            Object.keys(selectedCities).forEach(function (key) {
                selectedCities[key].forEach(function (cityData) {
                    if (allLabsData.length > 0) {
                        allLabsData.map(function (labDetails) {
                            if (cityData.name.toLowerCase() === labDetails.name.toLowerCase() && cityData.state.toLowerCase() === labDetails.state.toLowerCase()) {
                                filteredData_3.push(labDetails);
                            }
                        });
                    }
                });
            });
            setLabs(filteredData_3);
        }
    }, [selectedStates, selectedCities, selectedLabs]);
    var caches = React.useMemo(function () { return ({
        states: new react_virtualized_1.CellMeasurerCache({
            fixedWidth: true,
            minHeight: 50,
            defaultHeight: 100
        }),
        cities: new react_virtualized_1.CellMeasurerCache({
            fixedWidth: true,
            minHeight: 50,
            defaultHeight: 100
        }),
        labs: new react_virtualized_1.CellMeasurerCache({
            fixedWidth: true,
            minHeight: 50,
            defaultHeight: 100
        })
    }); }, []);
    var labExistHandler = function () {
        var _a;
        var selectedArray = isLabExistDetails.selectedData[isLabExistDetails.moduleName].filter(function (moduleDetails) { return moduleDetails.name.toLowerCase() != isLabExistDetails.featureName.toLowerCase(); });
        var obj = __assign(__assign({}, isLabExistDetails.selectedData), (_a = {}, _a[isLabExistDetails.moduleName] = selectedArray, _a));
        if (isLabExistDetails.section === 'States') {
            var updatedCities_2 = Object.fromEntries(Object.entries(selectedCities).filter(function (_a) {
                var key = _a[0];
                return key.toLowerCase() !== isLabExistDetails.featureName.toLowerCase();
            }));
            var updatedLabs_3 = {};
            Object.keys(updatedCities_2).forEach(function (key) {
                console.log(key, updatedCities_2[key]);
                updatedCities_2[key].forEach(function (cityDetails) {
                    updatedLabs_3[cityDetails.name] = selectedLabs[cityDetails.name];
                });
            });
            setSelectedLabs(updatedLabs_3);
            setSelectedCities(updatedCities_2);
            setSelectedStates(obj);
        }
        else if (isLabExistDetails.section === 'Cities') {
            var updatedLabs = Object.fromEntries(Object.entries(selectedLabs).filter(function (_a) {
                var key = _a[0];
                return key.toLowerCase() !== isLabExistDetails.featureName.toLowerCase();
            }));
            setSelectedLabs(updatedLabs);
            setSelectedCities(obj);
        }
        else if (isLabExistDetails.section === 'Labs') {
            setSelectedLabs(obj);
        }
        setIsLabExist(false);
    };
    var searchingHandler = function (val, section) {
        if (val.target.value) {
            setSearchTerm(val.target.value);
            if (section === 'Cities') {
                var filteredData = cities.filter(function (cityData) {
                    if (cityData.name.toLowerCase().includes(val.target.value.toLowerCase())) {
                        return cityData;
                    }
                });
                setFilteredCities(filteredData);
            }
            else if (section === 'Labs') {
                var filteredData = labs.filter(function (cityData) {
                    if (cityData.name.toLowerCase().includes(val.target.value.toLowerCase())) {
                        return cityData;
                    }
                });
                setFilteredLabs(filteredData);
            }
        }
        else {
            setFilteredCities(cities);
            setFilteredLabs(labs);
        }
    };
    React.useEffect(function () {
        caches.states.clearAll();
    }, [statesData]);
    React.useEffect(function () {
        caches.cities.clearAll();
    }, [cities]);
    React.useEffect(function () {
        caches.labs.clearAll();
    }, [labs]);
    var RegionRow = React.memo(function (_a) {
        var index = _a.index, key = _a.key, style = _a.style, parent = _a.parent, data = _a.data;
        var items = data.items, iconName = data.iconName, section = data.section, selectedData = data.selectedData, allModuleData = data.allModuleData, moduleData = data.moduleData, selectedFeatureHandler = data.selectedFeatureHandler, checkIsSelected = data.checkIsSelected, selectAllModuleWiseHandler = data.selectAllModuleWiseHandler, isAllSelectedModuleWise = data.isAllSelectedModuleWise, cache = data.cache;
        if (!items || !items[index]) {
            return null;
        }
        var feature = items[index];
        return (React.createElement(react_virtualized_1.CellMeasurer, { cache: cache, columnIndex: 0, key: key, rowIndex: index, parent: parent }, function (_a) {
            var registerChild = _a.registerChild;
            return (React.createElement("div", { ref: registerChild, style: __assign(__assign({}, style), { padding: '8px 16px' }) },
                React.createElement("div", { className: "feature-heading-wrapper" },
                    React.createElement(checkbox_component_1.default, { label: feature.name, handleChange: function (event) {
                            return selectAllModuleWiseHandler(event, feature.name, feature.regions, selectedData, section, allModuleData, moduleData);
                        }, checked: isAllSelectedModuleWise(feature, feature.name, selectedData) })),
                feature.regions && feature.regions.length > 0 && (React.createElement(React.Fragment, null,
                    React.createElement("p", { className: "section-desc" }, "Click on the above heading to select all the options or select one by one from below list."),
                    React.createElement("div", { className: "feature-chips-wrapper" }, feature.regions.map(function (x_feature, chipIndex) { return (React.createElement("label", { key: chipIndex, className: "chip-label custom-chip boxed-chip feature-chip ".concat(checkIsSelected(x_feature.name, feature.name, selectedData)
                            ? 'activeChip'
                            : '') },
                        React.createElement("input", { type: "checkbox", checked: checkIsSelected(x_feature.name, feature.name, selectedData), onChange: function (event) {
                                selectedFeatureHandler(event, feature.name, x_feature.id, section, x_feature.name, allModuleData, selectedData, moduleData, x_feature);
                            } }),
                        x_feature.name,
                        React.createElement("span", { className: iconName }))); }))))));
        }));
    });
    var renderChipsLeft = React.useCallback(function (items, iconName, section, selectedData) {
        var allModuleData = section === 'States' ? allCitiesData : section === 'Cities' ? allLabsData : [];
        var moduleData = section === 'States' ? cities : section === 'Cities' ? labs : [];
        var sortedItems = items === null || items === void 0 ? void 0 : items.sort(function (a, b) { return (a.name > b.name ? 1 : -1); });
        var cache = caches[section.toLowerCase()];
        return (React.createElement("div", { className: "section-container" },
            section !== 'States' && (React.createElement("div", { className: "select-all-wrapper", style: { display: 'flex', justifyContent: 'space-between' } },
                React.createElement(checkbox_component_1.default, { label: "Select All ".concat(section), handleChange: function (event) { return selectAllHandler(event, section); }, checked: isAllModulesSelected(items, section === 'Cities' ? selectedCities : selectedLabs) }),
                React.createElement("div", { className: "filter-menu-wrapper long-filter" },
                    React.createElement("div", { className: "search-filter search-lg" },
                        React.createElement(search_component_1.default, { placeholder: "Search ".concat(section === 'Cities' ? 'States' : 'Cities'), searchValue: searchTerm, searchHandler: function (val) { return searchingHandler(val, section); } }))))),
            React.createElement("div", { className: "region-list-wrapper", style: { height: section === 'States' ? '550px' : '525px' } },
                React.createElement(react_virtualized_1.AutoSizer, null, function (_a) {
                    var height = _a.height, width = _a.width;
                    return (React.createElement(react_virtualized_1.List, { width: width, height: height, rowCount: sortedItems.length, rowHeight: cache.rowHeight, rowRenderer: function (_a) {
                            var index = _a.index, key = _a.key, style = _a.style, parent = _a.parent;
                            return (React.createElement(RegionRow, { index: index, key: key, style: style, parent: parent, data: {
                                    items: sortedItems,
                                    iconName: iconName,
                                    section: section,
                                    selectedData: selectedData,
                                    allModuleData: allModuleData,
                                    moduleData: moduleData,
                                    selectedFeatureHandler: selectedFeatureHandler,
                                    checkIsSelected: checkIsSelected,
                                    selectAllModuleWiseHandler: selectAllModuleWiseHandler,
                                    isAllSelectedModuleWise: isAllSelectedModuleWise,
                                    cache: cache
                                } }));
                        }, overscanRowCount: 5, deferredMeasurementCache: cache }));
                }))));
    }, [selectedFeatureHandler, checkIsSelected]);
    return company ? (React.createElement("div", { className: "transfer-list-wrapper" },
        React.createElement(material_1.Grid, { container: true, columnSpacing: 2 },
            React.createElement(material_1.Grid, { item: true, xs: 12, sm: 12, md: 5.8, lg: 3.8 },
                React.createElement("div", { className: "options-containers features-details-wrapper" },
                    React.createElement("h2", { className: "section-title" }, "States"),
                    React.createElement("p", { className: "section-desc" }, "Please select the states you want to assign.")),
                React.createElement("div", { className: "list-container-wrapper" }, statesData && ((_b = statesData[0]) === null || _b === void 0 ? void 0 : _b.regions) && statesData[0].regions.length > 0 ? renderChipsLeft(statesData, 'icon-add', 'States', selectedStates) :
                    React.createElement("div", { className: 'list-no-data-wrapper' },
                        React.createElement("span", { style: { padding: '10px', border: '2px solid #E0E0E0', borderRadius: '4px', fontFamily: 'inherit', backgroundColor: 'whitesmoke' } }, "No states data found")))),
            React.createElement(material_1.Grid, { item: true, xs: 0, sm: 0, md: 0.1, lg: 0.1, sx: { display: { xs: 'none', md: 'block' } } },
                React.createElement("div", { style: {
                        borderLeft: '1px solid #e0e0e0',
                        height: '100%',
                        width: '0',
                    } })),
            React.createElement(material_1.Grid, { item: true, xs: 12, sm: 12, md: 5.9, lg: 3.9 },
                React.createElement("div", { className: "options-containers features-details-wrapper" },
                    React.createElement("h2", { className: "section-title" }, "Cities"),
                    React.createElement("p", { className: "section-desc" }, "Please select the cities you want to assign.")),
                React.createElement("div", { className: "list-container-wrapper" }, cities && cities.length > 0 ? renderChipsLeft(filteredCities.length > 0 ? filteredCities : cities, 'icon-add', 'Cities', selectedCities) :
                    React.createElement("div", { className: 'list-no-data-wrapper' },
                        React.createElement("span", { style: { padding: '10px', border: '2px solid #E0E0E0', borderRadius: '4px', fontFamily: 'inherit', backgroundColor: 'whitesmoke' } }, "No cities data found")))),
            React.createElement(material_1.Grid, { item: true, xs: 0, sm: 0, md: 0, lg: 0.1, sx: { display: { xs: 'none', md: 'none', lg: 'block' } } },
                React.createElement("div", { style: {
                        borderLeft: '1px solid #e0e0e0',
                        height: '100%',
                        width: '0',
                    } })),
            React.createElement(material_1.Grid, { item: true, xs: 12, sm: 12, md: 6, lg: 3.9 },
                React.createElement("div", { className: "options-containers features-details-wrapper" },
                    React.createElement("h2", { className: "section-title" }, "Labs"),
                    React.createElement("p", { className: "section-desc" }, "Please select the labs you want to assign.")),
                React.createElement("div", { className: "list-container-wrapper" }, labs && labs.length > 0 ? renderChipsLeft(filteredLabs.length > 0 ? filteredLabs : labs, 'icon-add', 'Labs', selectedLabs) :
                    React.createElement("div", { className: 'list-no-data-wrapper' },
                        React.createElement("span", { style: { padding: '10px', border: '2px solid #E0E0E0', borderRadius: '4px', fontFamily: 'inherit', backgroundColor: 'whitesmoke' } }, "No labs data found"))))),
        React.createElement(pop_up_1.default, { open: isLabExist },
            React.createElement("div", { className: "modal-header" },
                React.createElement("h2", { className: "heading" }, "Confirm State Lab Removal"),
                React.createElement("h2", { className: "sub-heading" }, "Do you want to remove the selected state labs as well?")),
            React.createElement("div", { className: "modal-footer sticky-modal-footer" },
                React.createElement(button_component_1.default, { buttonName: "Cancel", color: "yellow-outline", isError: false, onClickHandler: function () { return setIsLabExist(false); } }),
                React.createElement(button_component_1.default, { buttonName: "Remove", color: "yellow", onClickHandler: function () { return labExistHandler(); }, isError: false }))))) : null;
};
exports.default = RegionSelector;
